import { EngHttpClient } from "../../../../common/services/eng-http-client.service";
import { ApiResult } from "../../../../common/models";
import { tagLibraryConfig } from "../config/tag-library.config";

export interface TagLibraryResponse {
  name: string;
  id?: string | number;
  // Add other properties as needed based on the actual API response
}

// Interface for the full API response structure
interface TagLibraryApiResponse {
  success: boolean;
  tagLibrary: TagLibraryResponse[];
}

export class TagLibraryService extends EngHttpClient {
  static async getAllTagLibraries(): Promise<ApiResult<TagLibraryResponse[]>> {
    const config = tagLibraryConfig.getAllTagLibraries();
    try {
      // Use the full response structure type
      const response = await this.invokeApi<TagLibraryApiResponse>(config);

      // Extract the tagLibrary array from the response
      const tagLibraryData = response.value?.tagLibrary || [];

      return new ApiResult<TagLibraryResponse[]>(
        tagLibraryData,
        response.statusCode,
        ...response.errors
      );
    } catch (error) {
      console.error("Error fetching tag library configurations:", error);
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error occurred";
      return new ApiResult<TagLibraryResponse[]>([] as any, 500, errorMessage);
    }
  }
}
